// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qv-2";
export var chatLink = "_qv-0";
export var chatText = "_qv-1";